import { Trans } from "@lingui/macro";
import { IApiEpBillingProductFeatureSubscription } from "@smp/api";
import { UiBox } from "@smp/ui";

import { useEpBillingFeature } from "@/hooks/use_ep_billing_feature";

export const CompositionFeatureSubscription = ({
  productFeatureSubscription,
}: {
  productFeatureSubscription: IApiEpBillingProductFeatureSubscription;
}) => {
  const { feature } = useEpBillingFeature({
    req: {
      path: { id: productFeatureSubscription.feature },
    },
  });

  if (!feature) {
    return null;
  }

  return (
    <UiBox display="flex" flexDirection="row">
      <UiBox flexGrow={1} pl={2}>
        {feature.name === "watermark_slot" ? (
          <Trans>Quantity</Trans>
        ) : (
          <Trans>Duration</Trans>
        )}
      </UiBox>
      <UiBox flexGrow={1} textAlign="right">
        {feature.name === "video_posting"
          ? productFeatureSubscription.period_days
          : 1}
      </UiBox>
    </UiBox>
  );
};
